export default "__VITE_ASSET__BpVEmQI4__"